import { render, staticRenderFns } from "./EditorBooks.vue?vue&type=template&id=9848d96c&scoped=true&"
import script from "./EditorBooks.vue?vue&type=script&lang=js&"
export * from "./EditorBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9848d96c",
  null
  
)

export default component.exports